module.exports = __webpack_public_path__ + "img/64.4.NH3-N.86507848.png";